import { Collapse, DatePicker } from "antd";
import styled from "styled-components";

export const CustomDatePicker = styled(DatePicker)`
  .ant-picker-input > input {
    text-align: center;
  }
`;

// TODO: Collapse close animation sets inline style height to 0px before class min-height is applied causing flicker on collapse. Min-height pseudo elements also didn't work
export const CollapsibleDynamicFilters = styled(Collapse)`
  .ant-collapse-item {
    display: flex;
    flex-direction: column;
  }
  .ant-collapse-header {
    order: 2;
    margin-left: auto;

    &[aria-expanded] {
      padding: 0 16px;
    }

    > .ant-collapse-expand-icon > .ant-collapse-arrow {
      font-size: 18px;
    }
  }
  .ant-collapse-content {
    &.ant-collapse-content-active,
    &.ant-collapse-content-inactive {
      min-height: 4em !important;
      > .ant-collapse-content-box {
        padding: 0 8px;
      }
    }
    &.ant-collapse-content-hidden,
    &.ant-collapse-content-inactive[style*='display: none'] {
      display: block !important;
      min-height: 4em !important;
      max-height: 4em;
      overflow: hidden;
    }
  }
`;
